<template>
    <div class="listmain ">
         <h1 class="firTitle">多轮对话协议</h1>
              <p>根据开发者在技能开放平台配置的语音交互模型设置的相关槽位标识以JSON消息格式传递多轮对话内容
              </p>

              <h5 class="thirdTitle">请求头信息：</h5>
              <p>POST : /intent/invoke HTTP/1.1
                <br>Content-Type : application/x-www-form-urlencoded;charset=UTF-8
                <br>Host : ovs.ainirobot.com
                <br>Content-Length:
                <br>Accept : application/json
                <br>Accept-Charset : utf-8

              </p>
               <h5 class="thirdTitle">请求内容格式规范及参数说明</h5>

              <h5 class="codeTitle">多轮对话协议（示例）</h5>
              <highlight-code lang="javascript">
            "directives": [//Type:JSONArray
        { //Type:JSONObject,多轮协议描述
            "type": "Dialog.ElicitSlot",//Type:String
            //单槽位期望，仅一个槽位就能确定期望值，用户确定的值会放到updatedIntent中。
            "slotToElicit": "fromCity",//Type:String/JSONObject
            //多槽位期望，需要多个槽位来确定一个指，用户需求自行记录值，不会放到updatedIntent中。
            "slotToElicit":{//Type:JSONObject
                "command_param":"温度"//Type:String
                "command_value":""//Type:String,期望获得的槽位写成空字符串
            }
            "updatedIntent": {//Type:JSONObject
                "slots": {//Type:JSONObject
                    "toCity": {//Type:JSONObject
                        "name": "toCity"//Type:String
                    },
                    "travelDate": {//Type:JSONObject
                        "name": "travelDate",//Type:String
                        "value": "2017-04-21"//Type:String
                    },
                    "fromCity": {//Type:JSONObject
                        "name": "fromCity"//Type:String
                    },
                    "activity": {//Type:JSONObject
                        "name": "activity"//Type:String
                    },
                    "travelMode": {//Type:JSONObject
                        "name": "travelMode"//Type:String
                    }
                }
            }
        }


             </highlight-code>



    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/tutor/zdyjn_dldh.vue